"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveDateByUnits = void 0;
const luxon_1 = require("luxon");
function moveDateByUnits(date, dateTimeUnit, magnitude) {
    const magnitudeSign = Math.sign(magnitude);
    let runningDate = luxon_1.DateTime.fromISO(date);
    for (let i = 0; i < Math.abs(magnitude); i++) {
        if (magnitudeSign === 1) {
            runningDate = runningDate.endOf(dateTimeUnit);
        }
        else if (magnitudeSign === -1) {
            runningDate = runningDate.startOf(dateTimeUnit);
        }
        runningDate = runningDate.plus({ days: magnitudeSign });
    }
    return runningDate;
}
exports.moveDateByUnits = moveDateByUnits;
//# sourceMappingURL=index.js.map